import { REFUND_STATUS as RefundStatusMap, type RefundStatus } from '@hooks-api/types/dataModel/eCommerceOrders'
import { HStack } from '@pets-ui/HStack/HStack'
import { QuestionOutlined } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import { useTranslation } from 'react-i18next'

interface Props {
  refundStatus?: RefundStatus | null
  isMerchant: boolean
}

export function RefundStatusBadge({ refundStatus, isMerchant }: Props) {
  const { t } = useTranslation()

  if (refundStatus === RefundStatusMap.MANUAL_REFUND) {
    const manualRefundTooltipText = isMerchant
      ? t('orderDetail.manualRefundTip', { defaultValue: '如有疑問請聯繫業務' })
      : t('orderDetail.manualRefundTip2C', { defaultValue: '如有疑問請聯繫客服' })
    return (
      <HStack gap={0.5} alignItems="center">
        <Text color={colors.grey600}>{t('orderDetail.manualRefund', { defaultValue: '人工處理' })}</Text>
        <Tooltip
          placement="bottom"
          variant="dark"
          PaperProps={{ maxWidth: 180 }}
          title={(
            <Text>
              {manualRefundTooltipText}
            </Text>
          )}
        >
          <QuestionOutlined color={colors.grey600} fontSize={12} />
        </Tooltip>
      </HStack>
    )
  }

  if (refundStatus === RefundStatusMap.REFUNDED) {
    return (
      <HStack gap={0.5} alignItems="center">
        <Text color={colors.grey600}>{t('orderDetail.refunded', { defaultValue: '退款完成' })}</Text>
        <Tooltip
          placement="bottom"
          variant="dark"
          PaperProps={{ maxWidth: 180 }}
          title={(
            <Text>
              {t('orderDetail.refundedTip', { defaultValue: '實際入帳依付款方式與銀行作業時間為準' })}
            </Text>
          )}
        >
          <QuestionOutlined color={colors.grey600} fontSize={12} />
        </Tooltip>
      </HStack>
    )
  }

  if (refundStatus === RefundStatusMap.REFUND_FAILED) {
    const refundFailedText = isMerchant
      ? t('orderDetail.refundFailed', { defaultValue: '請聯繫業務處理退款' })
      : t('orderDetail.refundFailed2C', { defaultValue: '請聯繫客服處理退款' })
    return (
      <Text color={colors.red600}>{refundFailedText}</Text>
    )
  }

  return null
}
